<template>
  <p
    class="text"
    :style="{ color, fontSize, fontWeight, lineHeight }"
    :class="[activeLang === 'ja-JP' && 'active-lang']"
  >
    {{ title }}
  </p>
</template>

<script lang="ts">
import { defineComponent, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'Text',
  components: {},
  props: {
    title: String,
    color: String,
    fontSize: String,
    fontWeight: String,
    lineHeight: String
  },
  setup() {
    const { locale } = useI18n();
    const activeLang = ref(localStorage.getItem('locale'));

    watch(
      locale,
      () => {
        activeLang.value = localStorage.getItem('locale');
      },
      { deep: true }
    );
    return {
      activeLang
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.active-lang {
  font-family: 'Tayori Noto Sans JP' !important;
  font-size: 4.8rem;
}
.text {
  font-family: 'Tayori-Roboto';
  color: $textDark;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 3.2rem;
  display: flex;
  align-items: center;

  &.active-lang {
    font-family: 'Tayori Noto Sans JP' !important;
  }
}
</style>
